import { combineReducers } from 'redux';
import { routerStateReducer as router } from 'redux-router';
import { reducer as form } from 'redux-form';
import auth from './auth';
import firebase from './firebase';
import channels from './channels';
import messages from './messages';
import users from './users';

export default combineReducers({
  auth,
  firebase,
  form,
  router,
  channels,
  messages,
  users
});



// WEBPACK FOOTER //
// ./src/reducers/index.js